export const GROWTHTOOLS_FILTRATION = {
    SOURCE_TYPE: [
        { label: "Все источники", value: "all" },
        { label: "Пользователи", value: "user" },
        { label: "Классики", value: "classic" },
        { label: "Научное сообщество", value: "science" },
        { label: "Редакция сервиса", value: "editorial" },
        { label: "Нейросеть", value: "ai" },
    ] as const,
    CONTENT_TYPE: [
        { label: "Все типы", value: "all" },
        { label: "Текст", value: "text" },
        { label: "Аудио", value: "audio" },
        { label: "Видео", value: "video" },
    ] as const,
}
